export const setDropdown = (state) => ({ type: 'SET_DROPDOWN', payload: state })
